<div>
  <input
      (click)="toggleColorPicker()"
      (change)="valueChanged($event)"
      (focusout)="focusLost($event)"
      cdkOverlayOrigin
      #colorInputField
      #trigger="cdkOverlayOrigin"
      [(ngModel)]="color"
      class="color-input"
      [maxLength]="7"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly" />
  <span class="color-preview" [ngStyle]="{'background-color': color}" (click)="toggleColorPicker()"></span>
</div>
<ng-template
          cdkConnectedOverlay
          (backdropClick)="closeColorPicker()"
          (overlayOutsideClick)="closeColorPicker()"
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="colorPickerOpen">
    <color-chrome
          [disableAlpha]="true"
          color="{{value}}"
          (onChangeComplete)="handleColorSelection($event)"></color-chrome>
</ng-template>
